module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-2800.94051218.svg";